import React, { useState, useEffect } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { TextField } from '@material-ui/core'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import axios from 'axios'
import ReactSelect from "../../UI/ReactSelectNotClear";


const initialValues = {
  name: '',
  deviceModelId:""
}

export default function Create(props) {
  const { show, onHide, onDeviceTypes , deviceModelId,filterInputs, orderBy, sortField, skip, take} = props
  const [isError, setIsError] = useState('')
  const [isLoading, setIsLoading] = useState(false);
  const [deviceModelOption, setDeviceModelOption] = React.useState(null);

  const CreateSchema = Yup.object().shape({
    name: Yup.string()
      .required('Ad tələb olunur.'),
      deviceModelId: Yup.string()
      .required('Model tələb olunur.'),
  })

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false
    }

    return false
  }

  const onPostDeviceType = (values,resetForm, setSubmitting) => {
    setIsLoading(true);
    const deviceType = {
      name:values.name,
      deviceModelId:values.deviceModelId

    }
    axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}deviceType`,
      data: deviceType,
    
    })
      .then((res) => {
        onDeviceTypes(orderBy, sortField, skip, take, filterInputs,)
        setSubmitting(false)
        resetForm()
        onHide(false)
        setIsLoading(false);

      })
      .catch((err) => {
        let message =
          typeof err.response !== "undefined"
            ? err.response.data.message
            : err.message;
        setIsError(message);
        setIsLoading(false);
      });
  }

  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostDeviceType(values,resetForm, setSubmitting)
    },
  })

  const resetForm = () => {
    onHide()
    formik.resetForm()
  }

  useEffect(() => {
    setIsError('')
  }, [show])

  function handleChangeDeviceModel(value) {
    setDeviceModelOption(value);
    formik.setFieldValue("deviceModelId", value.value);
  }
  return (
    <Modal
      size="md"
      aria-labelledby="create"
      centered
      className="modal pr-0"
      show={show}
      onHide={resetForm}
    >
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="create">Əlavə et</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="name"
                    name="name"
                    label="Ad"
                    placeholder="Ad"
                    className="w-100"
                    error={getInputClasses('name')}
                    {...formik.getFieldProps('name')}
                  />
                </div>
                {formik.touched.name && formik.errors.name ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.name}</div>
                  </div>
                ) : null}
              
          </div>
          <div className="col-12 col-md-12 col-lg-12">
            <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
            <input
            type="text"
            name="deviceModelId"
            hidden
            {...formik.getFieldProps("deviceModelId")}
          />

          <ReactSelect
            suggestions={deviceModelId}
            handleChangeSingle={handleChangeDeviceModel}
            single={deviceModelOption}
            label="Model seçin"
            placeholder="Model seçin"
            inputId="deviceModelId"
          />
            </div>
            {formik.touched.deviceModelId && formik.errors.deviceModelId ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.deviceModelId}</div>
              </div>
            ) : null}
              
          
         
         
              {isError && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block MuiFormLabel-root Mui-error">
                    {isError}
                  </div>
                </div>
              )}
            </div>
            </div>

          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              onHide(false)
              formik.resetForm()
            }}
          >
            Ləğv et
          </Button>
          <Button type="submit" className={isLoading ? "px-9" : ""}>
            <span>Əlavə et</span>
            {isLoading && <span className="ml-3 spinner spinner-white"></span>}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}
